import { AppointmentFinancialInputModel } from '../models/InputModels/AppointmentFinancialInputModel'
import { PenFileInputModel } from '../models/InputModels/PenFileInputModel'
import { PatientProfileViewModel } from '../models/ViewModels/PatientProfileViewModel'
import { RecordViewModel } from '../models/ViewModels/RecordViewModel'
import { RequestInterface } from './RequestInterface'

class RaytebRequests {
  Appointment_Deserve_POST = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Appointment/Deserve`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Appointment_DeserveConfirm_POST = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Appointment/DeserveConfirm`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Appointment_PartialDeserveConfirm_POST = ({
    headers,
    token,
  }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Appointment/PartialDeserveConfirm`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Appointment_List_POST = <PayLoad>({
    headers,
    token,
  }): RequestInterface<PayLoad> => {
    return {
      url: `/api/DoctorProfile/Appointment/List`,
      method: 'POST',
      headers: headers,
      authToken: token,
    }
  }
  StatisticsAppointment_POST = <PayLoad>({
    headers,
    token,
  }): RequestInterface<PayLoad> => {
    return {
      url: `/api/DoctorProfile/Appointment/StatisticsAppointment`,
      method: 'POST',
      headers: headers,
      authToken: token,
    }
  }
  Appointment_ListTicketRequest_POST = <PayLoad>({
    headers,
    token,
  }): RequestInterface<PayLoad> => {
    return {
      url: `/api/DoctorProfile/Appointment/ListTicketRequest`,
      method: 'POST',
      headers: headers,
      authToken: token,
    }
  }
  Appointment_SetMeeting_POST = ({
    token,
    headers
  }): RequestInterface<SetMeetingInterface> => {
    return {
      url: `/api/DoctorProfile/Appointment/SetMeeting`,
      method: 'POST',
      authToken: token,
      headers: headers
    }
  }
  Appointment_ToggleIsEndTicketRequest_POST = ({
    token,
    headers
  }): RequestInterface<ToggleIsEndTicketRequestInputModel> => {
    return {
      url: `/api/DoctorProfile/Appointment/ToggleIsEndTicketRequest`,
      method: 'POST',
      authToken: token,
      headers: headers
    }
  }
  Dashboard_Login_POST = (): RequestInterface<LoginInputModel> => {
    return { url: `/api/DoctorProfile/Dashboard/Login`, method: 'POST' }
  }
  Dashboard_Logout_GET = ({ token, browserUniqueKey }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Dashboard/Logout?browserUniqueKey=${browserUniqueKey}`,
      method: 'GET',
      authToken: token,
    }
  }
  Dashboard_RefreshToken_POST = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Dashboard/RefreshToken`, method: 'POST' }
  }
  Dashboard_IHIOLogin_POST = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Dashboard/IHIOLogin`, method: 'POST' }
  }
  Dashboard_IHIOVerifyLogin_POST = (): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Dashboard/IHIOVerifyLogin`,
      method: 'POST',
    }
  }
  Dashboard_Get_GET = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Dashboard/Get`, method: 'GET' }
  }
  Doctor_Doctor_GET = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Doctor`, method: 'GET' }
  }
  Doctor_GetDoctorServe_GET = ({ token, centerId }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Doctor/GetDoctorServe`,
      method: 'GET',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Doctor_GetDoctorCenter_GET = ({ token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Doctor/GetDoctorCenter`,
      method: 'GET',
      authToken: token,
    }
  }
  Doctor_GetCenterConfig_GET = ({ token, headers }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Doctor/GetCenterConfig`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Doctor_DoctorServeShifts_GET = ({ token, centerId }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Doctor/GetDoctorServeShifts`,
      method: 'GET',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Imaging_ServeGroups_GET = (): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Imaging/ServeGroups/ServeGroups`,
      method: 'GET',
    }
  }
  Imaging_Serves_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      prescriptionId: string
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/Serves`,
      method: 'GET',
      authToken: token,
    }
  }
  Imaging_AddOrUpdate_POST = ({
    token,
  }): RequestInterface<ImagingSaveInputModel> => {
    return {
      url: `/api/DoctorProfile/Imaging/AddOrUpdate`,
      method: 'POST',
      authToken: token,
    }
  }
  Imaging_Remove_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/Remove`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Imaging_GetPrice_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/GetPrice`,
      method: 'GET',
      authToken: token,
    }
  }
  Laboratory_Serves_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      prescriptionId: string
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/Serves`,
      method: 'GET',
      authToken: token,
    }
  }
  Laboratory_AddOrUpdate_POST = ({
    token,
  }): RequestInterface<LaboratorySaveInputModel> => {
    return {
      url: `/api/DoctorProfile/Laboratory/AddOrUpdate`,
      method: 'POST',
      authToken: token,
    }
  }
  Laboratory_Remove_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/Remove`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Laboratory_GetPrice_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/GetPrice`,
      method: 'GET',
      authToken: token,
    }
  }
  Medication_Drugs_GET = (
    { chosen, isIRC, filter }: MedicationDrugInterfaceInputModel,
    { headers, token }
  ): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Medication/Drugs?isIRC=${isIRC}&chosen=${chosen}&filter=${filter}`,
      method: 'GET',
      headers: headers,
      authToken: token,
    }
  }
  Medication_Drug_GET = ({ code }: { code: string }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Medication/Drug/${code}`,
      method: 'GET',
    }
  }
  Medication_Amounts_GET = (): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Medication/Amounts`,
      method: 'GET',
    }
  }
  Medication_DrugRequirements_GET = ({ headers, token }): RequestInterface<unknown, { insuranceType: number }> => {
    return {
      url: `/api/DoctorProfile/Medication/DrugRequirements`,
      method: 'GET',
      headers: headers,
      authToken: token,
    }
  }
  Medication_Frequencys_GET = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Medication/Frequencys`,
      method: 'GET',
      headers: headers,
      authToken: token,
    }
  }
  Medication_AddOrUpdate_POST = ({
    description,
    token,
  }: {
    description: string
    token?: string | null
  }): RequestInterface<SaveMedicationInputModel> => {
    return {
      url: `/api/DoctorProfile/Medication/AddOrUpdate?description=${description}`,
      method: 'POST',
      authToken: token,
    }
  }
  Medication_AddRange_POST = ({
    token,
  }: {
    token?: string | null
  }): RequestInterface<SaveMedicationRangeInputModel> => {
    return {
      url: `/api/DoctorProfile/Medication/AddRange`,
      method: 'POST',
      authToken: token,
    }
  }
  Medication_GetLastMedication_GET = ({
    token,
  }: {
    token?: string | null
  }): RequestInterface<SaveMedicationInputModel, { code: string }> => {
    return {
      url: `/api/DoctorProfile/Medication/GetLastMedication`,
      method: 'GET',
      authToken: token,
    }
  }
  Medication_Remove_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/Remove`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Medication_GetPrice_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/GetPrice`,
      method: 'GET',
      authToken: token,
    }
  }
  Patient_List_POST = ({
    token,
    centerId,
  }): RequestInterface<PatientListInputModel> => {
    return {
      url: `/api/DoctorProfile/Patient/List`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Patient_Save_POST = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Patient/Save`, method: 'POST' }
  }
  Patient_ChnageMobile_POST = ({
    token,
    centerId,
  }): RequestInterface<ChnageMobileInputModel> => {
    return {
      url: `/api/DoctorProfile/Patient/ChangeMobile`,
      method: 'POST',
      headers: { centerId: centerId },
      authToken: token,
    }
  }
  Patient_ZipPatientProfiles_GET = ({
    token,
    centerId,
  }): RequestInterface<
    unknown,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Patient/ZipPatientProfiles`,
      method: 'GET',
      headers: { centerId: centerId },
      authToken: token,
    }
  }
  Patient_PrintPatientProfileWithPrescription_GET = ({
    token,
  }): RequestInterface<
    string,
    {
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Patient/PrintPatientProfileWithPrescription`,
      method: 'GET',
      authToken: token,
    }
  }
  Patient_GetAllProfiles_GET = ({
    token,
  }): RequestInterface<
    string,
    {
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Patient/GetAllProfiles`,
      method: 'GET',
      authToken: token,
    }
  }
  Physiotherapy_Serves_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      prescriptionId: string
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Physiotherapy/Serves`,
      method: 'GET',
      authToken: token,
    }
  }
  Physiotherapy_AddOrUpdate_POST = ({
    token,
  }): RequestInterface<PhysiotherapySaveInputModel> => {
    return {
      url: `/api/DoctorProfile/Physiotherapy/AddOrUpdate`,
      method: 'POST',
      authToken: token,
    }
  }
  Physiotherapy_Remove_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Physiotherapy/Remove`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Physiotherapy_GetPrice_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Physiotherapy/GetPrice`,
      method: 'GET',
      authToken: token,
    }
  }
  Prescription_Get_POST = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Prescription/Get`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Prescription_GetPrescriptionReferral_POST = ({
    token,
  }): RequestInterface<GetPrescriptionReferralInputModel> => {
    return {
      url: `/api/DoctorProfile/Prescription/GetPrescriptionReferral`,
      method: 'POST',
      authToken: token,
    }
  }
  Prescription_Push_POST = ({
    token,
  }): RequestInterface<PushPrescriptionInputModel> => {
    return {
      url: `/api/DoctorProfile/Prescription/Push`,
      method: 'POST',
      authToken: token,
    }
  }
  Prescription_Print_GET = (
    token: string
  ): RequestInterface<
    unknown,
    {
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Prescription/Print`,
      method: 'GET',
      authToken: token,
    }
  }
  Prescription_GetForUnRegisterUser_GET = (
    token: string,
    headers
  ): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Prescription/GetForUnRegisterUser`,
      method: 'POST',
      authToken: token,
      headers: headers
    }
  }
  Profile_Profile_GET = ({
    headers,
    token,
  }): RequestInterface<
    unknown,
    {
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/Fetch`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Profile_GetPatientReocrds_GET = ({
    headers,
    token,
  }): RequestInterface<
    unknown,
    {
      patientCode: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/GetPatientReocrds`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Profile_GetSummary_GET = ({
    headers,
    token,
  }): RequestInterface<
    unknown,
    {
      patientCode: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/GetSummary`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Profile_GetPatientProfiles_GET = ({
    token,
  }): RequestInterface<
    string,
    {
      centerId: number
      patientCode: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/GetPatientProfiles`,
      method: 'GET',
      authToken: token,
    }
  }
  Profile_PrintPatientProfiles_GET = ({
    token,
  }): RequestInterface<
    string,
    {
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/PrintPatientProfiles`,
      method: 'GET',
      authToken: token,
    }
  }
  Profile_SavePen_POST = ({
    token,
  }): RequestInterface<string, PenFileInputModel> => {
    return {
      url: `/api/DoctorProfile/Profile/SavePen`,
      method: 'POST',
      authToken: token,
    }
  }
  Profile_SaveAttachFile_POST = ({
    token,
  }): RequestInterface<{ file: string }> => {
    return {
      url: `/api/DoctorProfile/Profile/SaveAttachFile`,
      method: 'POST',
      authToken: token,
    }
  }
  Profile_Profile_POST = ({
    headers,
    token,
  }): RequestInterface<RecordViewModel> => {
    return {
      url: `/api/DoctorProfile/Profile/Save`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Profile_Cataloges_GET = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Profile/Cataloges`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Profile_Drugs_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/Drugs`,
      method: 'GET',
      authToken: token,
    }
  }
  Profile_Serves_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/Serves`,
      method: 'GET',
      authToken: token,
    }
  }
  Profile_GetDisease_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      filter: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Profile/GetDisease`,
      method: 'GET',
      authToken: token,
    }
  }
  Queue_Get_GET = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Queue/Get`, method: 'GET' }
  }
  Queue_Call_POST = ({
    headers,
    token,
  }): RequestInterface<unknown, { ticketId: string; room: number }> => {
    return {
      url: `/api/DoctorProfile/Queue/Call`,
      method: 'POST',
      headers: headers,
      authToken: token,
    }
  }
  Queue_Recall_GET = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Queue/Recall`, method: 'POST' }
  }
  Queue_Absent_POST = ({
    headers,
    token,
  }): RequestInterface<unknown, { ticketId: string; room: number }> => {
    return {
      url: `/api/DoctorProfile/Queue/Absent`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Referral_GetServe_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      phrase: string
      count: number
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Referral/GetServe`,
      method: 'GET',
      authToken: token,
    }
  }
  Referral_AddOrUpdate_POST = ({
    token,
  }): RequestInterface<ReferralInputModel, { prescriptionId: string }> => {
    return {
      url: `/api/DoctorProfile/Referral/AddOrUpdate`,
      method: 'POST',
      authToken: token,
    }
  }
  Referral_Delete_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Referral/Delete`,
      method: 'POST',
      authToken: token,
    }
  }
  Report_Finantial_GET = ({
    headers,
    token,
  }): RequestInterface<unknown, AppointmentFinancialInputModel> => {
    return {
      url: `/api/DoctorProfile/Report/Finantial`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Report_CalculateFinancials_GET = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Report/CalculateFinancials`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Report_Prescriptions_POST = (): RequestInterface => {
    return { url: `/api/DoctorProfile/Report/Prescriptions`, method: 'POST' }
  }
  TicketServe_Serves_GET = ({
    headers,
    token,
  }): RequestInterface<
    unknown,
    {
      filter: string
      isSepas: boolean
    }
  > => {
    return {
      url: `/api/DoctorProfile/TicketServe/Serves`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  TicketServe_AddOrUpdate_POST = ({
    token,
  }): RequestInterface<TicketServeInputModel> => {
    return {
      url: `/api/DoctorProfile/TicketServe/AddOrUpdate`,
      method: 'POST',
      authToken: token,
    }
  }
  TicketServe_Remove_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      id: string
      ticketId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/TicketServe/Remove`,
      method: 'DELETE',
      authToken: token,
    }
  }
  TicketServe_TicketServesByPrintCode_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      printCode: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/TicketServe/TicketServesByPrintCode`,
      method: 'GET',
      authToken: token,
    }
  }
  TicketServe_GetPrice_GET = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/TicketServe/GetPrice`,
      method: 'GET',
      authToken: token,
    }
  }
  TicketServe_PresentationTicketServes_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
      prescriptionId: string
      count: number
    }
  > => {
    return {
      url: `/api/DoctorProfile/TicketServe/PresentationTicketServes`,
      method: 'POST',
      authToken: token,
    }
  }
  Medication_Bookmark_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      medicationId: string
      title: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/Bookmark`,
      method: 'POST',
      authToken: token,
    }
  }
  Medication_BookmarkDrug_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      rowId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/BookmarkDrug`,
      method: 'POST',
      authToken: token,
    }
  }
  Medication_BookmarkDrugDelete_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      code: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/BookmarkDrugDelete`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Medication_Bookmark_Get = ({ token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Medication/Bookmark`,
      method: 'GET',
      authToken: token,
    }
  }

  Medication_Bookmark_Delete = ({
    token,
  }): RequestInterface<unknown, { bookmarkId }> => {
    return {
      url: `/api/DoctorProfile/Medication/Bookmark`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Medication_AddChosen_Post = ({
    token,
  }): RequestInterface<
    unknown,
    { prescriptionId: string; medicationId: string }
  > => {
    return {
      url: `/api/DoctorProfile/Medication/AddChosen`,
      method: 'POST',
      authToken: token,
    }
  }
  Laboratory_Bookmark_Get = ({ token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Laboratory/Bookmark`,
      method: 'GET',
      authToken: token,
    }
  }
  Laboratory_Bookmark_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      laboratoryId: string
      title: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/Bookmark`,
      method: 'POST',
      authToken: token,
    }
  }
  Laboratory_Bookmark_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      bookmarkId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/Bookmark`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Laboratory_AddChosen_Post = ({
    token,
  }): RequestInterface<
    unknown,
    { prescriptionId: string; laboratoryId: string }
  > => {
    return {
      url: `/api/DoctorProfile/Laboratory/AddChosen`,
      method: 'POST',
      authToken: token,
    }
  }
  Imaging_Bookmark_Get = ({ token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Imaging/Bookmark`,
      method: 'GET',
      authToken: token,
    }
  }
  Imaging_Bookmark_POST = ({
    token,
  }): RequestInterface<
    unknown,
    {
      imagingId: string
      title: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/Bookmark`,
      method: 'POST',
      authToken: token,
    }
  }
  Imaging_Bookmark_DELETE = ({
    token,
  }): RequestInterface<
    unknown,
    {
      bookmarkId: string
    }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/Bookmark`,
      method: 'DELETE',
      authToken: token,
    }
  }
  Imaging_AddChosen_Post = ({
    token,
  }): RequestInterface<
    unknown,
    { prescriptionId: string; imagingId: string }
  > => {
    return {
      url: `/api/DoctorProfile/Imaging/AddChosen`,
      method: 'POST',
      authToken: token,
    }
  }
  Prescription_GetAll_Get = ({
    token,
    centerId,
  }): RequestInterface<unknown, ListPrescriptionInputModel> => {
    return {
      url: `/api/DoctorProfile/Prescription/GetAll`,
      method: 'GET',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Setting_LoginIHIO_Post = ({
    token,
    centerId,
  }): RequestInterface<LoginIHIOInputModel> => {
    return {
      url: `/api/DoctorProfile/Setting/IHIOLogin`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Setting_IHIOVerifyLogin_Post = ({
    token,
    centerId,
  }): RequestInterface<IHIOVerifyLoginInputModel> => {
    return {
      url: `/api/DoctorProfile/Setting/IHIOVerifyLogin`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  Setting_TaminLogin_Post = ({
    token,
  }): RequestInterface<TaminLoginInterface> => {
    return {
      url: `/api/DoctorProfile/Setting/TaminLogin`,
      method: 'POST',
      authToken: token,
    }
  }
  DoctorTimeSheet_GetDoctorTimeSheets_Post = ({
    token,
    centerId,
  }): RequestInterface<DoctorTimeSheetInputModel> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/GetDoctorTimeSheets`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  DoctorTimeSheet_GetDoctorTimeSheetById_Post = ({
    token,
  }): RequestInterface<{ id: string }> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/GetDoctorTimeSheetById`,
      method: 'POST',
      authToken: token,
    }
  }
  DoctorTimeSheet_Create_Post = ({
    token,
    centerId,
  }): RequestInterface<DoctorTimeSheetCreateInputModel> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/Create`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  DoctorTimeSheet_Update_Post = ({
    token,
    centerId,
  }): RequestInterface<DoctorTimeSheetUpdateInputModel> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/Update`,
      method: 'POST',
      authToken: token,
      headers: { centerId: centerId },
    }
  }
  DoctorTimeSheet_DeleteById_Post = ({
    token,
  }): RequestInterface<{ id: string }> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/DeleteById`,
      method: 'POST',
      authToken: token,
    }
  }
  DoctorTimeSheet_DeleteRange_Post = ({
    token,
  }): RequestInterface<DoctorTimeSheetDeleteRangeInputModel> => {
    return {
      url: `/api/DoctorProfile/DoctorTimeSheet/DeleteRange`,
      method: 'POST',
      authToken: token,
    }
  }
  Management_Get_GET = ({
    headers,
    token,
  }): RequestInterface<
    ManagementViewModel,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Management/Get`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Management_GetAppointmentCount_GET = ({
    headers,
    token,
  }): RequestInterface<
    Array<ManagementDataPerDateViewModel<number>>,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Management/GetAppointmentCount`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Management_GetVisitCount_GET = ({
    headers,
    token,
  }): RequestInterface<
    Array<ManagementDataPerDateViewModel<number>>,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Management/GetVisitCount`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Management_GetPaymentsCount_GET = ({
    headers,
    token,
  }): RequestInterface<
    Array<ManagementDataPerDateViewModel<number>>,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Management/GetPaymentsCount`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Management_GetInsuranceSharePayments_GET = ({
    headers,
    token,
  }): RequestInterface<
    Array<InsuranceSharePaymentsViewModel>,
    {
      from: Date
      to: Date
    }
  > => {
    return {
      url: `/api/DoctorProfile/Management/InsuranceSharePaymentsCount`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  IHIO_GetListSamad_POST = ({
    headers,
    token,
  }): RequestInterface<ListSamadInputModel> => {
    return {
      url: `/api/DoctorProfile/IHIO/GetListSamad`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  IHIO_GetListSamadDelivered_POST = ({
    headers,
    token,
  }): RequestInterface<ListSamadInputModel> => {
    return {
      url: `/api/DoctorProfile/IHIO/GetListSamadDelivered`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  IHIO_GetListBill_POST = ({
    headers,
    token,
  }): RequestInterface<BillInputModel> => {
    return {
      url: `/api/DoctorProfile/IHIO/GetListBill`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  IHIO_GetPrescription_POST = ({
    headers,
    token,
  }): RequestInterface<GetPrescriptionIHIOInputModel> => {
    return {
      url: `/api/DoctorProfile/IHIO/GetPrescription`,
      method: 'POST',
      authToken: token,
      headers: headers,
    }
  }
  Downloads_GetBackupRecord_GET = ({ headers, token }): RequestInterface => {
    return {
      url: `/api/DoctorProfile/Downloads/GetBackupRecord`,
      method: 'GET',
      authToken: token,
      headers: headers,
    }
  }
  Slider_GET = ({ token }): RequestInterface<unknown, { type: 0 | 1 }> => {
    return {
      url: `/api/DoctorProfile/Slider`,
      method: 'GET',
      authToken: token,
    }
  }
  ChatRoom_GetToken = (): RequestInterface<{ accessToken: string }> => {
    return {
      url: `/api/ChatRoom/GetToken`,
      method: 'POST',
    }
  }
  ChatRoom_GetMessage = (accessToken: string): RequestInterface => {
    return {
      url: `/api/ChatRoom/GetMessage`,
      method: 'GET',
      authToken: accessToken
    }
  }
  ChatRoom_GetMessageChatGroup = (accessToken: string): RequestInterface => {
    return {
      url: `/api/ChatRoom/GetMessageChatGroup`,
      method: 'GET',
      authToken: accessToken
    }
  }
  ChatRoom_GetUser = (accessToken: string): RequestInterface => {
    return {
      url: `/api/ChatRoom/GetUser`,
      method: 'GET',
      authToken: accessToken
    }
  }
  ChatRoom_GetChatStatus = (accessToken: string): RequestInterface => {
    return {
      url: `/api/ChatRoom/GetChatStatus`,
      method: 'GET',
      authToken: accessToken
    }
  }
  ChatRoom_UploadFile = (): RequestInterface<FormData> => {
    return {
      url: `/api/ChatRoom/UploadFile`,
      method: 'POST',
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    }
  }
  Notification_AddOrUpdateClient = (): RequestInterface<CreateNotificationClientInterface> => {
    return {
      url: `/api/Notification/AddOrUpdateClient`,
      method: 'POST'
    }
  }
  Notification_ExistsClientForUser = (): RequestInterface<ExistsClientForUserNotiInputModel> => {
    return {
      url: `/api/Notification/ExistsClientForUser`,
      method: 'POST'
    }
  }
  Notification_GetNotificationKeys = (): RequestInterface => {
    return {
      url: `/api/Notification/GetNotificationKeys`,
      method: 'GET'
    }
  }
}

export default new RaytebRequests()
